import QISignTheme from '../../../interfaces/Theme';
import CreditCard from '../CreditCard';
import * as S from './styles';

declare type TwoCreditCardsProps = {
    title?: string;
    clientThemeSettings: QISignTheme;
    frontlabel?: string;
    backLabel?: string;
}

export default function TwoCreditCards({
    title,
    clientThemeSettings,
    frontlabel,
    backLabel
}: TwoCreditCardsProps) {
    return (
        <S.Container>
            <S.BackCard>
                <CreditCard title={title} type="secondary" clientThemeSettings={clientThemeSettings} cardLabel={backLabel}/>
            </S.BackCard>

            <S.FrontCard>
                <CreditCard title={title} type="primary" clientThemeSettings={clientThemeSettings} cardLabel={frontlabel}/>
            </S.FrontCard>
        </S.Container>
    )
}
